<template>
  <ClientOnly>
    <el-popover
      popper-class="content-popover"
      trigger="click"
      width="auto"
      :transition="'el-fade-in-linear'"
      :show-arrow="false"
      :visible="visible"
      placement="bottom-end"
    >
      <template #reference>
        <PrimaryButton
          v-click-outside="handleCloseButton"
          :data-target="`${routeName} ellipsis menu`"
          variant="secondary"
          class="w-10"
          @on-click="visible = !visible"
        >
          <ClientOnly>
            <font-awesome-icon
              v-if="rotation"
              :rotation="rotation"
              :icon="['fas', 'ellipsis']"
            />
            <font-awesome-icon v-else :icon="['fas', 'ellipsis']" />
          </ClientOnly>
        </PrimaryButton>
      </template>
      <slot />
    </el-popover>
  </ClientOnly>
</template>

<script setup lang="ts">
import { Ref, ref, computed } from "vue";
import { useNuxtApp } from "nuxt/app";
import PrimaryButton from "~/components/shared/primary-button/PrimaryButton.vue";
import { useCheckIntercomTourExists } from "@/composables/useCheckIntercomTourExists";
import Emitter from "~/types/Emitter";

const { $bus }: Emitter = useNuxtApp();

const { checkIntercomTourExists } = useCheckIntercomTourExists();

const visible: Ref<Boolean> = ref(false);
const routeName = computed(() => {
  if (!props.currentRoute) return "";
  return props.currentRoute[0].toUpperCase() + props.currentRoute.slice(1);
});

const props = defineProps({
  rotation: {
    type: Number,
    default: null,
  },
  currentRoute: {
    type: String,
    required: true,
  },
});

$bus.$on("CloseHamburgerButton", () => {
  handleCloseButton();
});

const handleCloseButton = () => {
  if (!checkIntercomTourExists()) {
    close();
  }
};

const close = () => {
  visible.value = false;
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Inter:300,400,700&display=swap");

.content-popover {
  @apply font-sans;
}
</style>
